import React from 'react';

import { CommonStatusTag } from 'components/CommonStatusTag';

import { colors } from 'constants/colors';

import { SubventionState, SUBVENTION_STATE_LABELS } from '../constants/states';

const getColorsFromState = (state: SubventionState) => {
    const { lightGrey, black, green } = colors;

    switch (state) {
        case SubventionState.Regular:
            return { backgroundColor: green, labelColor: black };
        case SubventionState.Archived:
            return { backgroundColor: lightGrey, labelColor: black };
    }
};

export const StatusTag = ({ state }: { state: SubventionState }) => {
    const { backgroundColor, labelColor } = getColorsFromState(state);
    return (
        <CommonStatusTag
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            label={SUBVENTION_STATE_LABELS[state]}
        />
    );
};
